import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query unitsDepartmentsPagination($page: Int, $pageSize: Int) {
  unitsDepartmentsPagination(page: $page, pageSize: $pageSize) {
    unitsDepartments {
      id
      name
      emails
      teams {
        id
        name
      }
      allTeamsOn
    }
    totalCount
    pageSize
  }
}`;

function getUnitsDepartmentsPagination(page, pageSize) {
  return apollo.client.query({
    query,
    variables: {
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.unitsDepartmentsPagination);
}

export default getUnitsDepartmentsPagination;
